import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '@/store/actions/user'
import { exec } from '@/api'
import Vue from 'vue'
import { AUTH_LOGOUT } from '@/store/actions/auth'

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  [USER_REQUEST]: async ({commit, dispatch}, user) => {
    commit(USER_REQUEST)
    var resp = await exec.getUser(user.id)
    if (resp.success) {
      commit(USER_SUCCESS, resp)
      localStorage.setItem('user-name', resp.first_name)
    } else {
      commit(USER_ERROR)
      dispatch(AUTH_LOGOUT)
    }
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js